import { Injectable } from '@angular/core';
import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent, HttpResponse, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';


@Injectable({
  providedIn: 'root'
})
export class IntercepterService {

   status:boolean = false

  constructor(private http: HttpClient, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   
    let token = JSON.parse(sessionStorage.getItem('access-token'))
    // debugger
     let url :any = req.url.split('?')[0]
    if (token && url != 'https://maps.googleapis.com/maps/api/geocode/json') {
    // console.log(token) 
    return next.handle(req.clone({ headers: req.headers.append('Authorization', 'Bearer ' + token) }))
        .pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse && ~(event.status / 100) > 3) {
              return event;
            }
            else {
              return event
            }
          }),
          catchError((err: any, caught) => {
            if (err instanceof HttpErrorResponse) {  
              if (err.status === 401) {
                if (!this.status) {
                  this.toastr.error("Session expired ! Try to login again")         
                  this.router.navigate(['/'], { queryParams: { returnUrl: this.router.routerState.snapshot.url }});
                }
               this.status = true
                this.spinner.hide()                
                // this.router.navigate(['/auth/login']);
              
              }
              if (err.status === 0) {
                this.router.navigate(['/auth/login']);
              }
              return throwError(err);
            }
          })
        );
    }
    else {
      return next.handle(req);
    }
  }
}
